import React, { useState, useEffect } from "react";
import { Row, Col, Container, Button, Collapse } from "reactstrap";
import styled from "styled-components";
import { RebelColors,
        RebelButton,
        RebelDangerButton,
        RebelModal,
        RebelModalHeader,
        RebelModalBody,
        RebelModalFooter} from "../../../styles/rebel-experiences";
import { BoldLabel,
        Spacer,
        UnderlineButton,
        transportationOptions,
        currencyOptions} from "../../../utils/budget-tool-specific";
import { validateExperienceForm } from "../../budget/common/helper";
import { listenToDocumentProperty, updateDocumentProperty, deleteNestedDocumentProperty, deleteNestedDocumentProperty3 } from "../../../utils/firestore-functions";
import { GetDB, generateGUID } from "../../../utils/database/firebase-budget-tool";
import RebelMiscellaneousInputs from "../rebel-experiences/components/rebel-miscellaneous-inputs";
import FormModals from "../experiences/cost-summary/form-modals";
import RebelFormInput from "../rebel-experiences/components/rebel-form-input";
import RebelFormInputExperienceMulti from "../rebel-experiences/components/rebel-form-input-exp-multi";
import FormInputExchange from "../budget-tool/input-components/form-input-exp-exchange";
import RebelFormInputPP from "../rebel-experiences/components/rebel-form-input-pp";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { RebelItem } from "../rebel-experiences/components/rebel-draggable";
import FormInput from "../budget-tool/input-components/form-input";
import firebase from "firebase/compat/app";

const RebelVillaTabForm = (props) => {
    const [costInputOpen, setCostInputOpen] = useState(true);

    const budgetDB = GetDB();
    const [villaData, setVillaData] = useState(
        {
            destCurrency: {value: "USD$", invalid: false, required: true},
            baseRate: {value: 1, invalid: false, required: true},
            convertRate: {value: 1, invalid: false, required: true},
            villaRentalFee: {value: 0, invalid: false, required: true},
            cleaningFee: {value: 0, invalid: false, required: true},
            flightCost: {value: 0, invalid: false, required: true},
            costPerTransportation: {value: 0, invalid: false, required: true},
            transportation: {value: [], invalid: false, required: true},
            costPerActivity: {value: 0, invalid: false, required: true},
            numActivities: {value: 0, invalid: false, required: true},
            costPerBreakfast: {value: 0, invalid: false, required: true},
            numBreakfast: {value: 0, invalid: false, required: true},
            costPerLunch: {value: 0, invalid: false, required: true},
            numLunch: {value: 0, invalid: false, required: true},
            costPerDinner: {value: 0, invalid: false, required: true},
            numDinner: {value: 0, invalid: false, required: true},
            costPerAlcohol: {value: 0, invalid: false, required: true},
            numAlcohol: {value: 0, invalid: false, required: true},
            roomRental: {value: {value: 0, pp: "per day"}, invalid: false, required: true},
            av: {value: {value: 0, pp: "per day"}, invalid: false, required: true},
            setupFee: {value: {value: 0, pp: "per day"}, invalid: false, required: true},
            numMeetings: {value: 0, invalid: false, required: true},
            costPerCoffee: {value: 0, invalid: false, required: true},
            numCoffee: {value: 0, invalid: false, required: true},
            miscellaneousCosts: {value: [], invalid: false, required: true},
            notes: {value: "", invalid: false, required: false},
            distanceFromAirport: {value: "", invalid: false, required: false},
            numberOfBedrooms: {value: 0, invalid: false, required: false},
            villaURL: {value: "", invalid: false, required: false},
            nearestCity: {value: "", invalid: false, required: false},
            distanceToCity: {value: "", invalid: false, required: false},
        })

    const dragEnd = (result) => {
        if (result.destination === undefined || result.destination === null){
            return;
        }
        const { destination, source, draggableId } = result;
        if (destination.droppableId === source.droppableId && destination.index === source.index){
            return;
        }
        let newData = {...villaData};
        let newArray = Array.from(newData.miscellaneousCosts.value);
        let obj = newArray[source.index];
        newArray.splice(source.index, 1);
        newArray.splice(destination.index, 0, obj);
        newData.miscellaneousCosts.value = newArray;
        setVillaData(newData);
    }

    useEffect(() => {
        var unsubscribe = listenToDocument(budgetDB, "rebelVillas", props.villaid, setVillaContent);
        return unsubscribe;
    },[]);

    useEffect(() => {
        if (props.setSaveVillaCostsRef) {
            props.setSaveVillaCostsRef(saveVillaCosts);
        }
    }, [villaData]);

    const listenToDocument = (db, collection, docId, callback) => {
        return db.collection(collection).doc(docId).onSnapshot((doc) => {
            if (doc.exists) {
                callback(doc.data());
            }
        });
    }

    const setVillaContent = (villa) => {
        let newData = {...villaData};

        if (villa.destCurrency !== undefined) newData.destCurrency.value = villa.destCurrency;
        if (villa.baseRate !== undefined) newData.baseRate.value = villa.baseRate;
        if (villa.convertRate !== undefined) newData.convertRate.value = villa.convertRate;
        if (villa.villaRentalFee !== undefined) newData.villaRentalFee.value = villa.villaRentalFee;
        if (villa.cleaningFee !== undefined) newData.cleaningFee.value = villa.cleaningFee;
        if (villa.flightCost !== undefined) newData.flightCost.value = villa.flightCost;
        if (villa.costPerTransportation !== undefined) newData.costPerTransportation.value = villa.costPerTransportation;
        if (villa.transportation !== undefined) newData.transportation.value = villa.transportation;
        if (villa.costPerActivity !== undefined) newData.costPerActivity.value = villa.costPerActivity;
        if (villa.numActivities !== undefined) newData.numActivities.value = villa.numActivities;
        if (villa.costPerBreakfast !== undefined) newData.costPerBreakfast.value = villa.costPerBreakfast;
        if (villa.numBreakfast !== undefined) newData.numBreakfast.value = villa.numBreakfast;
        if (villa.costPerLunch !== undefined) newData.costPerLunch.value = villa.costPerLunch;
        if (villa.numLunch !== undefined) newData.numLunch.value = villa.numLunch;
        if (villa.costPerDinner !== undefined) newData.costPerDinner.value = villa.costPerDinner;
        if (villa.numDinner !== undefined) newData.numDinner.value = villa.numDinner;
        if (villa.costPerAlcohol !== undefined) newData.costPerAlcohol.value = villa.costPerAlcohol;
        if (villa.numAlcohol !== undefined) newData.numAlcohol.value = villa.numAlcohol;
        if (villa.roomRental !== undefined) newData.roomRental.value = villa.roomRental;
        if (villa.av !== undefined) newData.av.value = villa.av;
        if (villa.setupFee !== undefined) newData.setupFee.value = villa.setupFee;
        if (villa.numMeetings !== undefined) newData.numMeetings.value = villa.numMeetings;
        if (villa.costPerCoffee !== undefined) newData.costPerCoffee.value = villa.costPerCoffee;
        if (villa.numCoffee !== undefined) newData.numCoffee.value = villa.numCoffee;
        if (villa.miscellaneousCosts !== undefined) newData.miscellaneousCosts.value = villa.miscellaneousCosts;
        if (villa.notes !== undefined) newData.notes.value = villa.notes;
        if (villa.distanceFromAirport !== undefined) newData.distanceFromAirport.value = villa.distanceFromAirport;
        if (villa.numberOfBedrooms !== undefined) newData.numberOfBedrooms.value = villa.numberOfBedrooms;
        if (villa.villaURL !== undefined) newData.villaURL.value = villa.villaURL;
        if (villa.nearestCity !== undefined) newData.nearestCity.value = villa.nearestCity;
        if (villa.distanceToCity !== undefined) newData.distanceToCity.value = villa.distanceToCity;

        setVillaData(newData);
    }

    let data = {
        destCurrency: villaData.destCurrency.value,
        baseRate: villaData.baseRate.value,
        convertRate: villaData.convertRate.value,
        villaRentalFee: villaData.villaRentalFee.value,
        cleaningFee: villaData.cleaningFee.value,
        flightCost: villaData.flightCost.value,
        costPerTransportation: villaData.costPerTransportation.value,
        transportation: villaData.transportation.value,
        costPerActivity: villaData.costPerActivity.value,
        numActivities: villaData.numActivities.value,
        costPerBreakfast: villaData.costPerBreakfast.value,
        numBreakfast: villaData.numBreakfast.value,
        costPerLunch: villaData.costPerLunch.value,
        numLunch: villaData.numLunch.value,
        costPerDinner: villaData.costPerDinner.value,
        numDinner: villaData.numDinner.value,
        costPerCoffee: villaData.costPerCoffee.value,
        numCoffee: villaData.numCoffee.value,
        costPerAlcohol: villaData.costPerAlcohol.value,
        numAlcohol: villaData.numAlcohol.value,
        setupFee: villaData.setupFee.value,
        roomRental: villaData.roomRental.value,
        av: villaData.av.value,
        numMeetings: villaData.numMeetings.value,
        miscellaneousCosts: villaData.miscellaneousCosts.value,
        notes: villaData.notes.value,
        distanceFromAirport: villaData.distanceFromAirport.value,
        numberOfBedrooms: villaData.numberOfBedrooms.value,
        villaURL: villaData.villaURL.value,
        nearestCity: villaData.nearestCity.value,
        distanceToCity: villaData.distanceToCity.value,
    }

    const [savedModal, setSavedModal] = useState(false);
    const [failedModal, setFailedModal] = useState(false);

    const [refresh, setRefresh] = useState(true);

    const toggleSavedModal = ( ) => { console.log("success"); setSavedModal(!savedModal) };
    const toggleFailedModal = ( ) => { setFailedModal(!failedModal) };

    const saveVillaCosts = () => {
        // Update all villa properties
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "destCurrency", data.destCurrency);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "baseRate", data.baseRate);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "convertRate", data.convertRate);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "villaRentalFee", data.villaRentalFee);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "cleaningFee", data.cleaningFee);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerTransportation", data.costPerTransportation);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "transportation", data.transportation);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerActivity", data.costPerActivity);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerBreakfast", data.costPerBreakfast);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerLunch", data.costPerLunch);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerDinner", data.costPerDinner);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerAlcohol", data.costPerAlcohol);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "roomRental", data.roomRental);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "av", data.av);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "setupFee", data.setupFee);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "costPerCoffee", data.costPerCoffee);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "miscellaneousCosts", data.miscellaneousCosts);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "notes", data.notes);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "distanceFromAirport", data.distanceFromAirport);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "numberOfBedrooms", data.numberOfBedrooms);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "villaURL", data.villaURL);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "nearestCity", data.nearestCity);
        updateDocumentProperty(budgetDB, "rebelVillas", props.villaid, "distanceToCity", data.distanceToCity, toggleSavedModal, toggleFailedModal);
        props.updateVillaDetails(props.villaid);
    }

    const addMiscellaneousCost = () => {
        let newData = {
            title: "",
            cost: 0,
            pp: "per person",
            id: generateGUID(),
        }

        let newMiscCost = [...villaData.miscellaneousCosts.value];
        newMiscCost.push(newData);

        let newVillaData = {...villaData};
        newVillaData.miscellaneousCosts.value = newMiscCost;
        setVillaData(newVillaData);

    }

    const deleteMiscCost = (miscID) => {
        let newVillaData = {...villaData};
        newVillaData.miscellaneousCosts.value = newVillaData.miscellaneousCosts.value.filter((key) => key.id !== miscID);
        setVillaData(newVillaData);
    };

    const handleMiscellaneousChange = (value, id, type) => {

        let miscCost = [...villaData.miscellaneousCosts.value];
        let index = miscCost.findIndex(p => p.id == id);
        if (type === "title") {
            miscCost[index].title = value;
        } else if (type === "cost") {
            miscCost[index].cost = value;
        } else if (type === "pp") {
            if (value === "per person") {
                miscCost[index].pp = "per trip";
            } else {
                miscCost[index].pp = "per person";
            }
        }

        let newVillaData = {...villaData};
        newVillaData.miscellaneousCosts.value = miscCost;
        setVillaData(newVillaData);
    }


    return (
        <React.Fragment>
             <RebelModal isOpen={savedModal} toggle={() => {setSavedModal(!savedModal)}}>
                <RebelModalHeader toggle={() => {setSavedModal(!savedModal)}}>Saved</RebelModalHeader>
                <RebelModalBody>
                Successfully saved property data to the database.
                </RebelModalBody>
                <RebelModalFooter>
                <RebelButton onClick={() => {setSavedModal(!savedModal)}}>
                    Okay
                </RebelButton>
                </RebelModalFooter>
            </RebelModal>
            <RebelModal isOpen={failedModal} toggle={() => {setFailedModal(!failedModal)}}>
                <RebelModalHeader toggle={() => {setFailedModal(!failedModal)}}>Failed to Save</RebelModalHeader>
                <RebelModalBody>
                There was an error saving the property data. Please try again.
                </RebelModalBody>
                <RebelModalFooter>
                <RebelButton onClick={() => {setFailedModal(!failedModal)}}>
                    Okay
                </RebelButton>
                </RebelModalFooter>
            </RebelModal>
            <StyledContainer id="cost-output-container">
            {!props.client &&
            <React.Fragment>
                <Collapse isOpen={costInputOpen}>
                <Row>
                    <Col>
                    <RebelFormInput title="Destination Currency"
                                            id="destCurrency" data={villaData}
                                            setData={(x) => setVillaData(x)}
                                            type="select"
                                            options={currencyOptions()}/>
                    </Col>
                </Row>
                <Row>
                    <Col><BoldLabel style={{color: RebelColors.primary}}>Accommodation</BoldLabel></Col>
                </Row>
                <Row>
                    <Col>
                        <RebelFormInput title="Property Rental Fee Per Night"
                                                id="villaRentalFee" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Cleaning Fee"
                                                id="cleaningFee" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col xs="6">
                    </Col>
                </Row>
                <Row id="first-section">
                    <Col>
                        <RebelFormInput title="Cost Per Activity"
                                                id="costPerActivity" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                    <RebelFormInput title="Cost Per Transportation"
                                                id="costPerTransportation" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col xs="4">
                        <RebelFormInputExperienceMulti title="Transportation Provided"
                                            id="transportation"
                                            data={villaData}
                                            setData={(x) => setVillaData(x)}
                                            options={transportationOptions}
                                            transportation={villaData.transportation}/>

                    </Col>

                </Row>
                <Row>
                    <Col><BoldLabel style={{color: RebelColors.primary}}>Meal Costs Per Attendee</BoldLabel></Col>
                </Row>
                <Row id="meals-section">
                    <Col>
                        <Row>
                            <Col>
                            <RebelFormInput title="Cost Per Breakfast"
                                                id="costPerBreakfast" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                            <Col>
                            <RebelFormInput title="Cost Per Lunch"
                                                id="costPerLunch" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                            <Col>
                            <RebelFormInput title="Cost Per Dinner"
                                                id="costPerDinner" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                            <Col>
                            <RebelFormInput title="Cost Per Snack"
                                                id="costPerAlcohol" data={villaData}
                                                setData={(x) => setVillaData(x)}
                                                currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col><BoldLabel style={{color: RebelColors.primary}}>Meetings Costs</BoldLabel></Col>
                </Row>
                <Row id="meals-section">
                    <Col>
                        <Row>
                            <Col>
                                <RebelFormInputPP title="Room Rental"
                                                    id="roomRental" data={villaData}
                                                    setData={(x) => setVillaData(x)}
                                                    currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>
                            <Col>
                                <RebelFormInputPP title="Setup Fees"
                                                    id="setupFee" data={villaData}
                                                    setData={(x) => setVillaData(x)}
                                                    currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>
                            <Col>
                                <RebelFormInputPP title="AV"
                                                    id="av" data={villaData}
                                                    setData={(x) => setVillaData(x)}
                                                    currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>
                            <Col>
                                <RebelFormInput title="Cost Per Coffee"
                                                    id="costPerCoffee" data={villaData}
                                                    setData={(x) => setVillaData(x)}
                                                    currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col><BoldLabel style={{color: RebelColors.primary}}>Miscellaneous Costs</BoldLabel></Col>
                </Row>

                {villaData.miscellaneousCosts.value !== undefined && refresh && <DragDropContext onDragEnd={(result) => dragEnd(result)}>
                    <Droppable droppableId="1" isDropDisabled={false}>
                        {(provided) => (<div ref={provided.innerRef} {...provided.droppableProps}>
                                {Object.entries(villaData.miscellaneousCosts.value).map((obj, index) => (
                                    <RebelItem index={index} id={obj[1].id} key={obj[1].id} miscCost={obj} currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""} deleteMiscCost={(x) => deleteMiscCost(x)} handleMiscellaneousChange={handleMiscellaneousChange} i={index}></RebelItem>
                                ))}
                            {provided.placeholder}
                        </div>)}
                    </Droppable>
                </DragDropContext>}

                {false && villaData.miscellaneousCosts.value !== undefined && refresh && Object.entries(villaData.miscellaneousCosts.value).map((miscCost, i) => {

                    if (miscCost !== undefined) {
                        return(
                            <RebelMiscellaneousInputs  key={i} miscCost={miscCost} currency={villaData.destCurrency.value ? villaData.destCurrency.value.slice(3): ""} deleteMiscCost={(x) => deleteMiscCost(x)} handleMiscellaneousChange={handleMiscellaneousChange} i={i}/>
                        )
                    }
                })}

                <Row>
                    <Col>
                        <StyledButton onClick={(x) => addMiscellaneousCost(x)}>Add miscellaneous cost</StyledButton>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <RebelFormInput
                            key="notes"
                            title="Notes"
                            id="notes" data={villaData}
                            setData={(x) => setVillaData(x)}
                            type="text"/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RebelButton style={{margin: "20px 0px"}} onClick={(x) => saveVillaCosts(x)}>Save Property Costs</RebelButton>

                        {costInputOpen && <RebelUnderlineButton style={{margin: "20px 0px"}} onClick={(x) => setCostInputOpen(!costInputOpen)}>Hide property cost inputs</RebelUnderlineButton>}
                    </Col>
                </Row>

                <Spacer/>

                </Collapse>

                </React.Fragment>}
                {!costInputOpen && <RebelUnderlineButton style={{margin: "20px 0px"}} onClick={() => setCostInputOpen(!costInputOpen)}>Show property cost inputs</RebelUnderlineButton>}

        </StyledContainer>
        </React.Fragment>
    )
}

export default RebelVillaTabForm;

const StyledContainer = styled.div`
    margin-left: 1px;
    margin-right: 1px;
    padding: 15px;
    border-radius: 0px 0px 10px 10px;
    border: 1px solid ${RebelColors.border}
`

const StyledButton = styled(Button)`
    background-color: ${RebelColors.gold};
    border: 0px;
    color: #000000;
    font-weight: 600;

    &:hover {
        background-color: #d4af37;
        color: #000000;
    }
`

const RebelUnderlineButton = styled(UnderlineButton)`
    color: ${RebelColors.primary};

    &:hover {
        color: ${RebelColors.gold};
    }
`
